<style lang="scss">
  @import '../resources/scss/digital_library.scss';
</style>

<script lang="ts">
  import type LibrarySection from '../api/rest/directus-cms/digitalgrow/models/LibrarySection'
  import MoreInfoLinkBtn from './MoreInfoLinkBtn.svelte'

  export let section: LibrarySection
</script>

{#if section}
  <section id="digital-library">
    <div class="container-fluid bg-secondary_m py-section">
      <div class="container-xxl">
        <div class="row">
          <div class="col-12">
            <h1 class="text-primary-blue mb-4">{section.title}</h1>
            <h4 class="text-primary-blue mb-4">
              {@html section.text}
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4 mt-lg-0">
            <div class="metric-container row g-4">
              {#each section.metrics as metric}
                <div class="col-12 col-md-6">
                  <div class="metric">
                    <div class="metric-value-container text-primary-blue">
                      <span class="h2 metric-value fix-line-height">{metric.value}</span>
                      <span class="h4 metric-label">{metric.name}</span>
                    </div>
                    <div>
                      <img src={metric.icon?.fullUrl} alt={metric.name} />
                    </div>
                  </div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>
    {#if section.topics}
      <div class="container-xxl py-section">
        <div class="row">
          <div class="col-12">
            <h2 class="text-primary-blue">{section.topics_title}</h2>
          </div>
        </div>
        <div class="row g-4 pt-3">
          {#each section.topics as topic}
            <div class="col-12 col-lg-6">
              <MoreInfoLinkBtn link={topic.link} name={topic.name} btnClass="blue" />
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </section>
{/if}
